/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core'
@Injectable()
export class MasterDataConstant {
    //Old v1 API
    public CountryList : any;
    public CountryGroupList : any;
    public AreaList : any;
    public ApplicationList : any;
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/masterdata.constant.ts